import './styles.scss';

import React, {CSSProperties} from 'react';

import {NavLink} from 'react-router-dom';

export interface AppNavMenuItemProps {
    text: string;
    routeTo: string;
}

interface AppNavMenuProps {
    items: AppNavMenuItemProps[];
    style?: CSSProperties;
}

export const AppNavMenu = ({items, style}: AppNavMenuProps) => {
    return (
        <div className='app-nav-menu' style={style}>
            {items.map((item) => (
                <NavLink key={item.routeTo} to={item.routeTo} className='app-nav-menu__item'>
                    {item.text}
                </NavLink>
            ))}
        </div>
    );
};
